import { ChangeDetectionStrategy, Component, inject, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { AlertService, NotificationService } from '@app/core';
import { ContentType } from '@app/core/models/content-type.enum';
import { SubdivionService } from '@app/core/services/subdivisions.service';
import { notNull, safeEmpty } from '@app/shared/utils';
import { POPOVER_DATA, PopoverRef } from '@app/shared/modules/template/components/popover';
import { TranslateService } from '@ngx-translate/core';
import { exhaustMap, tap } from 'rxjs';
import { StudioFilterService } from '../../services';

@Component({
  templateUrl: './popover-subdivisions.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class PopoverSubdivisionsComponent {
  public readonly data = inject(POPOVER_DATA);
  public readonly popoverRef = inject<PopoverRef<string>>(PopoverRef);
  public readonly alertService = inject(AlertService);
  public readonly notificationService = inject(NotificationService);
  public readonly subdivionService = inject(SubdivionService);
  public readonly studioFilterService = inject(StudioFilterService);
  private readonly translate = inject(TranslateService);
  private readonly router = inject(Router);

  public onCreateSubdivision() {
    this.studioFilterService.passSubdivision({
      id: undefined,
      subdivisao_id: this.data.item.id,
      curso_id: this.data.item.curso_id,
      tipo: ContentType.Subdivisao,
      ordem: this.data.item.items.length,
      fixar: false,
    });
    this.popoverRef.close();
  }

  public onAddTrail() {
    this.router.navigate([
      new URL(window.location.href).pathname,
      'trilha',
      'cadastro',
      this.data.item.curso_id,
      this.data.item.id,
    ]);
    this.popoverRef.close();

    this.subdivionService.closeModal$.next(true);
  }

  public onDeleteSubdivision() {
    const itemToDeleteId = this.data.item.id;
    this.alertService
      .confirm({ message: 'trilhas.estudio.subdivisao.deseja-excluir' })
      .pipe(
        notNull(),
        exhaustMap(() => this.subdivionService.destroySubdivision(itemToDeleteId).pipe(safeEmpty())),
        tap({
          error: () => this.alertService.alert({ message: 'geral.alertas.erro-operacao' }),
        }),
      )
      .subscribe({
        next: (res) => {
          this.notificationService.success(this.translate.instant('geral.deletado'));
          this.studioFilterService.removeItem(itemToDeleteId, res, this.data.items);
          this.popoverRef.close();
        },
        error: (e) => this.alertService.alert({ message: e.error.msg }),
      });
  }

  public onEditSubdivision() {
    this.studioFilterService.passSubdivision(this.data.item);
    this.popoverRef.close();
  }
}
